import { render, staticRenderFns } from "./StoreAboutTab.vue?vue&type=template&id=aac1c5a0"
import script from "./StoreAboutTab.vue?vue&type=script&lang=js"
export * from "./StoreAboutTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports